import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import './Indices.css';
import axios from 'axios';

function Indices(){
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
      const loading = async ()=>{
        setLoading(false);
        await axios.post("google.com");
      }
      loading();    
    }, []);
    return (
        <div>
            <Box sx={{ width: '100%' }} p={1}>
                <LinearProgress/>
            </Box>
        </div>
    );
}

export {Indices};